const API_URL =  "https://gfiglj2onj.execute-api.eu-central-1.amazonaws.com/api";
export { API_URL };
